// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__1juTu","productName":"Table_productName__t4qYj"};